module.exports = __webpack_public_path__ + "img/caption_desktop_v1.78b0ddaf.png";